import { connect } from 'react-redux';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import cn from 'classnames';

import { auth, provider } from '../../utils/firebase';
import { googleLogin } from '../../actions/auth';

import styles from './GoogleButton.module.css';

const GoogleButton = (props) => {
  const { 
    children,
    googleLogin,
  } = props;
    
  const navigate = useNavigate();

  const handleLogin = async () => {
     try {
      const result = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const authData = {
        name: result.user.displayName,
        access_token: credential.accessToken,
      };
      googleLogin(authData, () => navigate('/'));
    } catch (error) {
      console.log('===Gmail ERROR', error);
    }
  };

  return (
    <div 
      className={cn('google-button', styles.googleButton)}
      onClick={handleLogin}
    >
      {children || 'Sign in with Google'}
    </div>
  );
};

const mapDispatchToProps = {
  googleLogin,
};

export default connect(null, mapDispatchToProps)(GoogleButton);